module.exports = __webpack_public_path__ + "media/images/img_house_purchasing_2-50dc1a1dc156a827a89c8d99ccc788be.png";